import { PlainModalContent, ScheduleEvent } from './DaySchedule.types'

/**
 * The modal content attached to a ScheduleEvent can be one of several
 * shapes. These guards encode which shape is present so the details modal
 * can branch cleanly on it. Kept pure and dependency-free so they are
 * trivial to unit-test.
 */

/**
 * A ScheduleEvent[] payload means "clicking this entry opens an agenda of
 * nested events" — used for overflow/grouped clusters.
 */
export const isScheduleEventList = <T extends ScheduleEvent>(
  content: T['modalContent'],
): content is T[] =>
  Array.isArray(content) && content.length > 0 && 'startTime' in content[0]

/**
 * A `{title?, content}` payload means "clicking this event opens a static
 * content pane" — used for one-off custom modal bodies.
 */
export const isPlainModalContent = (
  content: unknown,
): content is PlainModalContent =>
  !!content &&
  !Array.isArray(content) &&
  'content' in (content as Record<string, unknown>)
